import { getNodePathFromNodeOffset, RangeInternal } from '../abstractselection';
import { AnchorNode } from '../anchor';
import { NodeTextPosition } from '../domop';

export { applyHighlights } from './dom';
export { enterSelectionScope } from './interaction';
export { removeHighlights } from './dom';

function isTouch(evt: Event): evt is TouchEvent {
    return evt.type === 'touchstart' || evt.type === 'touchmove' || evt.type === 'touchend';
}

function getTouchLocation(evt: TouchEvent, id: null | number): ICursorType {
    for (let i = 0, ii = evt.changedTouches.length; i < ii; i++) {
        const t = evt.changedTouches[i];
        if (!id || t.identifier === id) {
            return { type: evt.type, x: t.pageX, y: t.pageY, touchID: t.identifier };
        }
    }
    for (let i = 0, ii = evt.touches.length; i < ii; i++) {
        const t = evt.touches[i];
        if (!id || t.identifier === id) {
            return { type: evt.type, x: t.pageX, y: t.pageY, touchID: t.identifier };
        }
    }
}

function isMouse(evt: Event): evt is MouseEvent {
    return evt.type === 'mousedown' || evt.type === 'mousemove' || evt.type === 'mouseup';
}

function getMouseLocation(evt: MouseEvent): ICursorType {
    return { type: evt.type, x: evt.pageX, y: evt.pageY, touchID: undefined };
}

export interface ICursorType {
    x: number;
    y: number;
    type: string;
    touchID: number;
}

export const getSelectionPathFromPositions = (root: AnchorNode, cursorStart: ICursorType, cursorEnd: ICursorType) => {
    if (!cursorStart || !cursorEnd) { return null; }

    const posStart = NodeTextPosition.fromPoint(cursorStart.x, cursorStart.y);
    if (!posStart) { return null; }

    const posEnd = NodeTextPosition.fromPoint(cursorEnd.x, cursorEnd.y);
    if (!posEnd) { return null; }

    const clipped = RangeInternal.fromTextPositions(posStart, posEnd);
    if (!clipped) { return null; }

    const pathStart = getNodePathFromNodeOffset(root, clipped.startContainer, clipped.startOffset);
    if (!pathStart) { return null; }

    const pathEnd = getNodePathFromNodeOffset(root, clipped.endContainer, clipped.endOffset);
    if (!pathEnd) { return null; }

    return { pathStart, pathEnd };
};

export const getCursorPositionFromEvent = (event: Event, touchID: number) => {
    if (isTouch(event)) {
        return getTouchLocation(event, touchID);
    }
    if (isMouse(event)) {
        return getMouseLocation(event);
    }
};



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/highlight/index.tsx